import React, { useState } from 'react';
import { Box, Flex } from 'rebass/styled-components';
import { X } from 'lucide-react';
import { Input } from '@getro/rombo';
import PropTypes from 'prop-types';

export const BoardEditColumnInput = ({ value, onChange, onCancel }) => {
  const [innerValue, setInnerValue] = useState(value);

  const onSubmit = () => {
    const newValue = innerValue.trim();

    if (newValue) {
      onChange(newValue, value);
    }
  };

  const onClickCancel = (event) => {
    event.stopPropagation();

    setInnerValue('');
    onCancel();
  };

  return (
    <Flex flexGrow={1}>
      <Input
        size="small"
        placeholder="Enter new column name"
        value={innerValue}
        autoFocus
        onChange={(e) => setInnerValue(e.target.value)}
        onBlur={onSubmit}
        onKeyDown={(e) => {
          if (e.key === 'Enter') {
            onSubmit();
          }
        }}
        sx={{
          flexGrow: 1,
        }}
      />
      <Flex
        alignItems="center"
        justifyContent="center"
        sx={{
          width: '32px',
          height: '32px',
          cursor: 'pointer',
          color: 'neutral.400',
          '&:hover': { color: 'neutral.500' },
        }}
        onClick={onClickCancel}
      >
        <Box as={X} height="16px" width="16px" aria-hidden="true" />
      </Flex>
    </Flex>
  );
};

BoardEditColumnInput.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};

BoardEditColumnInput.defaultProps = {
  value: '',
};
